import { shouldShowParentalRatingPopup } from '../../../helpers/common';

export type EpgProgramWithRatings =
    | {
          ratings?: unknown;
      }
    | null
    | undefined;

/**
 * Whether the active profile may not play this EPG listing (parental control).
 * Delegates to the shared rating ladder used by PlayVideoButton and catch-up.
 */
export const isEpgProgramParentalBlocked = (program: EpgProgramWithRatings): boolean =>
    Boolean(program?.ratings && shouldShowParentalRatingPopup(program.ratings));
